module.exports = __webpack_public_path__ + "static/media/btn_back2top.192d180b.svg";